export default class TipoAutorizacion {


    constructor() {
        this.Codigo = 0;
        this.Descripcion = "";
        this.prefijo = "";
    }
    Codigo: number;
    Descripcion: string;
    prefijo: string;

}